import { lazy, Suspense, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';

import { DemoModalProvider, ErrorFallback, ScrollToTop } from 'components';
import LandingPage from 'src/features/LandingPage';
import Veterinaro from 'src/features/Veterinaro';
import { initSmoothScroll } from 'src/utils/smoothScroll';

const Analysis = lazy(() => import('src/features/Analysis'));
const AnalysisRegulations = lazy(() => import('src/features/AnalysisRegulations'));
const NotFoundRoute = lazy(() => import('src/features/NotFoundRoute'));
const PrivacyPolicy = lazy(() => import('src/features/PrivacyPolicy'));
const Statute = lazy(() => import('src/features/Statute'));

// Pages removed in the redesign
const LEGACY_PATHS = ['/about', '/benefits', '/stories/*'];

const AppRouter = () => {
  useEffect(() => initSmoothScroll(), []);

  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <DemoModalProvider>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <ScrollToTop />
          <Suspense fallback={null}>
            <Routes>
              <Route
                path='/'
                element={<LandingPage />}
              />
              <Route
                path='/veterinaro'
                element={<Veterinaro />}
              />
              <Route
                path='/contact'
                element={
                  <Navigate
                    to='/#demo'
                    replace
                  />
                }
              />
              <Route
                path='/analysis'
                element={<Analysis />}
              />
              <Route
                path='/analysis/regulations'
                element={<AnalysisRegulations />}
              />
              <Route
                path='/privacy-policy'
                element={<PrivacyPolicy />}
              />
              <Route
                path='/statute'
                element={<Statute />}
              />
              {LEGACY_PATHS.map((path) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <Navigate
                      to='/'
                      replace
                    />
                  }
                />
              ))}
              <Route
                path='*'
                element={<NotFoundRoute />}
              />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </DemoModalProvider>
    </BrowserRouter>
  );
};

export default AppRouter;
